import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  MenuItem,
  Select,
  TextField,
  Typography,
  InputAdornment,
  Container,
} from "@mui/material";
import CalculateIcon from "@mui/icons-material/Calculate";
import { useFormik } from "formik";
import styles from "./EvaluationForm.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { EvaluationSchema } from "../../../forms/EvaluationValidation";
import { InitialValuesEvaluation } from "../../../types/formTypes";
import { useNavigate } from "react-router-dom";
import { useParams, Link } from "react-router-dom";
import { useMutationByMethod } from "../../../services/hooks/useMutationByMethod";
import { GetUrl, PostUrl } from "../../../api/endpointConfig";
import { useGet } from "../../../services/hooks/useGet";
import {
  ApplicantForm,
  DorpdownInterFace,
  FundsAllowDetailsInterface,
} from "../../../types/types";
import { useLoader } from "../../../Loader/LoaderContext";
import { addFundallowDetails } from "../../../redux/actions/Actions";
import { ToastService } from "../../../utils/toastService";
export const formatDateToReadable = (isoString: string): string => {
  const date = new Date(isoString);
  const options: Intl.DateTimeFormatOptions = {
    day: "2-digit",
    month: "long",
    year: "numeric",
  };
  return date.toLocaleDateString("en-GB", options).replace(" ", ", ");
};
const EvaluationForm = () => {
  const [mainData, setMainData] = useState<ApplicantForm[]>([]);
  const [dropDownData, setDropDownData] = useState<DorpdownInterFace[]>([]);
  const { showLoader, hideLoader } = useLoader();
  const applicationManageArr = useSelector(
    (state: RootState) => state.app.applicationManageData
  );
  const fundallocationData = useSelector(
    (state: RootState) => state.app.fundAllocation
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const formik = useFormik({
    initialValues: InitialValuesEvaluation,
    validationSchema: EvaluationSchema,
    onSubmit: (values) => {
      console.log("Submitted:", values);
      handleSubmit();
    },
  });
  const convertToISOString = (rawDate: string): string => {
    console.log("rawDate", fundallocationData);
    const year = rawDate?.slice(0, 4);
    const month = rawDate?.slice(4, 6);
    const day = rawDate?.slice(6, 8);

    const date = new Date(`${year}-${month}-${day}T00:00:00Z`);
    return date.toISOString(); // Output: 2025-06-13T00:00:00.000Z
  };
  const intialAppMutation = useMutationByMethod<any>(
    "post",
    `${PostUrl.intialApplication}`
  );
  const postAppIntialReq = async () => {
    let obj: any = {};
    if (formik.values.decision === "rejected") {
      obj = {
        interviwer_commnets: formik.values.remarks,
        application_status: formik.values.decision,
        application_id: Number(id || applicationManageArr[0]?.application_id),
        // scholarship: {
        //   scholarship_start_dt: "",
        //   scholarship_end_dt: "",
        //   fund_allocation: [],
        //   grand_total: formik.values.sanctionAmount,
        //   first_payment_dt: '',
        //   first_payment_amt: 0,
        //   coordinator: formik.values.coordinator
        // },
      };
    } else {
      const fundallocation = fundallocationData[0].funds.map((item) => {
        return {
          purpose: item.purpose,
          allocation_amount: item.allocationAmount,
          frequency: item.frequency,
          no_of_installment: item.installments,
          total_amt: item.totalAmount,
        };
      });
      obj = {
        interviwer_commnets: formik.values.remarks,
        application_status: formik.values.decision,
        application_id: Number(id || applicationManageArr[0]?.application_id),
        scholarship: {
          scholarship_start_dt: convertToISOString(
            fundallocationData[0]?.startDate as any
          ),
          scholarship_end_dt: convertToISOString(
            fundallocationData[0]?.endDate as any
          ),
          fund_allocation: fundallocation,
          grand_total: formik.values.sanctionAmount,
          first_payment_dt: "",
          first_payment_amt: 0,
          coordinator: formik.values.coordinator,
        },
      };
    }
    console.log("obj", obj);

    intialAppMutation.mutate(obj, {
      onSuccess: (data) => {
        ToastService.success("The scholarship has been granted successfully.");
        setTimeout(() => {
          navigate(`/application-management`);
        }, 4000);
      },
      onError: (err) => {
        console.error("error", err);
      },
    });
  };

  const handleSubmit = () => {
    postAppIntialReq();
  };

  useEffect(() => {
    if (fundallocationData) {
      const grandTotal = fundallocationData[0]?.funds.reduce(
        (acc, row) => acc + (Number(row.totalAmount) || 0),
        0
      );
      formik.setFieldValue("sanctionAmount", grandTotal);
    }
  }, [fundallocationData]);

  const getDropdownApi = useGet<any>(`${GetUrl.getApplicationDropdown}`);
  const getApplicationData = useGet<any>(
    applicationManageArr[0]?.application_id
      ? `${GetUrl.getApplication}?application_id=${applicationManageArr[0]?.application_id}`
      : "",
    {}, // Axios config (or undefined)
    !!applicationManageArr[0]?.application_id // enabled only if truthy
  );

  const fetchApplicationData = async () => {
    showLoader();
    try {
      const result = await getApplicationData.refetch();
      if (result.data) {
        setMainData([result.data]);
        dispatch(
          addFundallowDetails(
            result.data.scholarship as FundsAllowDetailsInterface
          ) as any
        );
        hideLoader();
      }
    } catch (error) {
      console.error("Error fetching app version:", error);
      hideLoader();
    } finally {
      hideLoader();
    }
  };
  const fetchDropdownData = async () => {
    try {
      const result = await getDropdownApi.refetch();
      if (result.data) {
        setDropDownData([result.data]);
      }
    } catch (error) {
      console.error("Error fetching app version:", error);
    }
  };

  useEffect(() => {
    fetchApplicationData();
    fetchDropdownData();
  }, [applicationManageArr[0]?.status]);
  useEffect(() => {
    formik.setFieldValue("interviewer", "Admin");
    if (mainData && applicationManageArr[0]?.status === "approved") {
      formik.setFieldValue("sanctionAmount", mainData[0]?.scholarship?.amount);
      formik.setFieldValue("decision", mainData[0]?.status);
      formik.setFieldValue(
        "coordinator",
        mainData[0]?.scholarship?.coordinator
      );
      formik.setFieldValue("remarks", mainData[0]?.interviwer_commnets);
    }
  }, [mainData]);
  const handleNavigation = () => {
    if (applicationManageArr[0]?.status === "approved") {
    }
    navigate("evaluationfund");
  };
  const decisionHandleChange = (val: any) => {
    if (val === "rejected") {
      formik.setFieldValue("sanctionAmount", 0);
    } else {
      if (fundallocationData.length > 0) {
        const grandTotal = fundallocationData[0]?.funds.reduce(
          (acc, row) => acc + (Number(row.totalAmount) || 0),
          0
        );
        formik.setFieldValue("sanctionAmount", grandTotal);
      } else {
        formik.setFieldValue("sanctionAmount", "");
      }
      // formik.setFieldValue("sanctionAmount", '');
    }
  };
  return (
    <Container
      className={styles.container}
      sx={{ width: "auto", margin: "1rem" }}
    >
      <Box className={styles.header}>
        <Typography variant="h5" className={styles.title}>
          Evaluation Form
        </Typography>
        <Box className={styles.navigationButtons}>
          <Button
            variant="contained"
            className={styles.saveButton}
            onClick={() => formik.handleSubmit()} // This will submit the current step's data
            disabled={applicationManageArr[0]?.status === "approved"}
          >
            Submit
          </Button>
        </Box>
      </Box>

      <Box className={styles.metaData}>
        <Typography>
          <strong>Applicant Name:</strong> {applicationManageArr[0]?.name}
        </Typography>
        <Typography>
          <strong>Application ID:</strong>{" "}
          {applicationManageArr[0]?.application_id}
        </Typography>
        <Typography>
          <strong>Application Date:</strong>{" "}
          {formatDateToReadable(mainData[0]?.updated_at)}
        </Typography>
        <Typography>
          <strong>Applicant Phone:</strong>{" "}
          {applicationManageArr[0]?.phone_number}
        </Typography>
        <Typography>
          <strong>Applicant Email:</strong> {applicationManageArr[0]?.email}
        </Typography>
      </Box>

      <form onSubmit={formik.handleSubmit} className="form-group">
        <Box className={styles.fieldRow} flexWrap={"wrap"}>
          <TextField
            fullWidth
            id="interviewer"
            name="interviewer"
            label="Interviewer *"
            value={formik.values.interviewer ?? ""}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.interviewer && Boolean(formik.errors.interviewer)
            }
            helperText={formik.touched.interviewer && formik.errors.interviewer}
            className={styles.textFourField}
          />

          <TextField
            fullWidth
            id="sanctionAmount"
            name="sanctionAmount"
            label="Sanction amount *"
            value={formik.values.sanctionAmount}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.sanctionAmount &&
              Boolean(formik.errors.sanctionAmount)
            }
            helperText={
              formik.touched.sanctionAmount && formik.errors.sanctionAmount
            }
            className={styles.textFourField}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <CalculateIcon />
                  <span
                    onClick={() => {
                      if (formik.values.decision !== "rejected") {
                        handleNavigation();
                      }
                    }}
                    className={styles.link}
                    title={
                      formik.values.decision === "rejected"
                        ? "Fund Allocation disabled for rejected applications"
                        : "Go to Fund Allocation"
                    }
                    style={{
                      cursor:
                        formik.values.decision === "rejected"
                          ? "not-allowed"
                          : "pointer",
                      color:
                        formik.values.decision === "rejected"
                          ? "#9e9e9e"
                          : undefined,
                      pointerEvents:
                        formik.values.decision === "rejected" ? "none" : "auto",
                    }}
                  >
                    Fund Allocation
                  </span>
                </InputAdornment>
              ),
              readOnly: true,
            }}
          />

          <TextField
            fullWidth
            id="decision"
            name="decision"
            select
            label="Final Decision *"
            value={formik.values.decision}
            onChange={(e) => {
              const val = e.target.value;
              formik.setFieldValue("decision", val);
              decisionHandleChange(val);
            }}
            onBlur={formik.handleBlur}
            error={formik.touched.decision && Boolean(formik.errors.decision)}
            helperText={formik.touched.decision && formik.errors.decision}
            className={styles.textFourField}
          >
            <MenuItem value="">Select Status</MenuItem>
            <MenuItem value="pending">Pending Additional documents</MenuItem>
            <MenuItem value="approved">Approved</MenuItem>
            <MenuItem value="rejected">Rejected</MenuItem>
            <MenuItem value="on_hold">On Hold</MenuItem>
          </TextField>
          <TextField
            fullWidth
            id="coordinator"
            name="coordinator"
            label="Co-ordinator"
            select
            value={formik.values.coordinator ?? ""}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.coordinator && Boolean(formik.errors.coordinator)
            }
            helperText={formik.touched.coordinator && formik.errors.coordinator}
            className={styles.textFourField}
          >
            <MenuItem value="">Select Coordinator</MenuItem>
            {dropDownData &&
              dropDownData[0]?.coordinators.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
          </TextField>
        </Box>

        <Box className={styles.fullWidthSection}>
          <Typography variant="body1" className={styles.sectionHeader}>
            Interviewer's Remarks *
          </Typography>
          <TextField
            fullWidth
            id="remarks"
            name="remarks"
            multiline
            rows={4}
            placeholder="Please provide your justification on the decision."
            value={formik.values.remarks}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.remarks && Boolean(formik.errors.remarks)}
            helperText={formik.touched.remarks && formik.errors.remarks}
            className={styles.textField}
          />
        </Box>

        {/* <Box className={styles.submitBox}>
          <Button
            variant="contained"
            color="success"
            type="submit"
            size="large"
          >
            Submit
          </Button>
        </Box> */}
      </form>
      <Box
        display={"flex"}
        justifyContent={"center"}
        className={styles.btnsPanel}
      >
        <Button
          variant="contained"
          className={styles.backButton}
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
      </Box>
    </Container>
  );
};

export default EvaluationForm;
